import { useTranslation } from "react-i18next";

export default function CategoricalStatsPanel({
  title,
  stats,
  totalLabel,
}) {
  const { t } = useTranslation();
  const resolvedTotalLabel =
    totalLabel || t("dashboard.stats.totalCategories", "Total de categories");

  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/70 p-4">
      <div className="text-sm font-medium text-slate-900">{title}</div>
      <div className="text-xs text-slate-500 mt-1 uppercase tracking-wide">
        categorical
      </div>

      <div className="mt-4 rounded-lg bg-white border border-slate-200 px-3 py-3">
        <div className="text-xs text-slate-500">{resolvedTotalLabel}</div>
        <div className="text-xl font-semibold text-slate-900 mt-1">
          {stats?.total ?? 0}
        </div>
      </div>

      <div className="mt-4 space-y-2">
        {(stats?.items || []).map((item) => (
          <div
            key={item.category}
            className="rounded-lg bg-white border border-slate-200 px-3 py-3"
          >
            <div className="flex items-center justify-between gap-3">
              <div className="text-sm font-medium text-slate-900">
                {item.category}
              </div>
              <div className="text-sm text-slate-600">
                {item.count} · {item.pct}%
              </div>
            </div>
          </div>
        ))}
        {!(stats?.items || []).length && (
          <div className="text-sm text-slate-500">
            {t("dashboard.stats.noCategories", "Sense categories disponibles.")}
          </div>
        )}
      </div>
    </div>
  );
}
